import { Dropdown } from 'prosemirror-menu';
function setActiveLabel(dropdown, dom, state) {
  const activeMenuItem = dropdown.content.find(function (e) {
    return e.spec.active(state);
  });
  if (activeMenuItem) {
    dropdown.options.label = activeMenuItem.spec.label;
    dom.querySelector('div').innerText = dropdown.options.label;
  }
}
export class WithActiveAsLabelDropdown extends Dropdown {
  render(view) {
    const {
      dom,
      update
    } = super.render(view);
    const updateWithSetActive = state => {
      setActiveLabel(this, dom, state);
      return update(state);
    };
    return {
      dom,
      update: updateWithSetActive
    };
  }
}